import { useEffect } from 'react';
import { useAuth, authStore } from './useAuth';
import { translations, resolveUserLanguage } from '../i18n';
import type { Language, Translations } from '../i18n';

/**
 * De taal en het woordenboek van de app (specs/20261016-taal-bewonersapp, T010).
 *
 * Eén hook voor de hele app, ook voor de spelletjes (`useGameLanguage` bestaat niet meer).
 * De taal komt uit `resolveUserLanguage`: appLanguage van de server → gameLanguage →
 * sitetaal → 'nl'. Wisselt de user (profile_refresh), dan rendert alles opnieuw.
 */
export function useTranslation(): { lang: Language; t: Translations } {
  const { user } = useAuth();
  const lang = resolveUserLanguage(user);

  useEffect(() => {
    try {
      document.documentElement.lang = lang;
    } catch {
      // geen document (test/SSR)
    }
  }, [lang]);

  return { lang, t: translations[lang] };
}

/** Huidige taal, voor code buiten React (bv. de commandohandler op moduleniveau). */
export function currentLanguage(): Language {
  return resolveUserLanguage(authStore.getState().user);
}

/** Huidig woordenboek, voor code buiten React. */
export function currentTranslations(): Translations {
  return translations[currentLanguage()];
}
